module.exports = "<div id=\"kt_header\" class=\"header header-fixed\">\n  <navbar></navbar>\n</div>\n<div id=\"kt_body\"\n\tclass=\"header-fixed header-mobile-fixed subheader-enabled subheader-fixed aside-enabled aside-fixed aside-minimize-hoverable page-loading\">\n  <!--begin::Main-->\n\t<div class=\"d-flex flex-column flex-root\" style=\"min-height: 96vh;\">\n    <!--begin::Page-->\n    <div ui-view style=\"overflow-y: auto; min-height: 96vh;\"></div>\n    <!--end::Page-->\n    <footer></footer>\n\t</div>\n  <!--end::Main-->\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/main/main.html
// module id = 496
// module chunks = 0